import {  WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import {   defaultDropList } from "../Data/WBComponentDefaults";
import React from "react";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import LayoutNode, { getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import WebDesigner from "../WebDesigner";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import MissingSourceDisplay from "vagaro-website-rendering/src/components/MissingSourceDisplay";
import CreateAttributeList from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";

export default class WBIframe extends WBComponent {

    constructor(){
        super();
        this.typename =wBComponentTypeNames.iFrame;
        this.displayName = "IFrame";
        this.dropList = defaultDropList;
        this.editList = ["iframeSrc",...CreateAttributeList(true,false,false,true,false)];
        this.primaryEditAttributes = ["iframeSrc"];
        this.contentEditable = false;
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor"><path d="M448 120c0-13.3-10.7-24-24-24l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L112 96l0-40c0-13.3-10.7-24-24-24S64 42.7 64 56l0 40L24 96C10.7 96 0 106.7 0 120s10.7 24 24 24l40 0 0 224-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 224 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-224 40 0c13.3 0 24-10.7 24-24zM112 368l0-224 224 0 0 224-224 0z"/></svg>
        
    }


    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {

        const iframeSrc = new AttributeDefinition("iframeSrc","Iframe Source","",AttributeInputType.URLField);
        iframeSrc.placeHolder  = "https://";
        return [
           iframeSrc,
        ];
    }


    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        thisLayout.screenSizeStyleAttributes[ScreenSize.Desktop] = {width:"500px",height:"500px"};
    }
    

    RenderLayout({component,children,screenSize,isEditor}:WBRenderProps)
     {


        let iframeSrc = getNodeComponentAttributeValue(component,"iframeSrc","");

        if(iframeSrc==""){

            return (
                <div {...GetNodeDomAttributes("v-iframe empty",component,screenSize,isEditor)}>
                       <MissingSourceDisplay/>
                </div>
            )
        }

        return (


            <div {...GetNodeDomAttributes("v-iframe",component,screenSize,isEditor)}>
                <iframe title="vagaro iframe" src={iframeSrc} sandbox="allow-forms allow-popups allow-scripts" ></iframe>

            </div>
        )

    }

}